// define the box SKUs
const largeBoxSKU = '46707850117444';
const smallBoxSKU = '42487207461035';
const timoutValue = 500;

// define the product types
const chainType = 'Chains';
const charmType = 'Charms';
const PendantType = 'Pendants';
const jewelBoxSmall = 'Jewel Box - Small';
const jewelBoxLarge = 'Jewel Box - Large';

document.addEventListener('cart:updated', function(event) {

    $.getJSON('/cart.js', function(cart) {
        cartData = cart;
        updateCounts();
    }); 
});


document.addEventListener("ajaxProduct:added", function(event) {
    $.getJSON('/cart.js', function(cart) {
        cartData = cart;
        updateCounts();
    }); 
});
  

// Get cart
function updateCounts() {
    // initialize the counts
    let chainCount = 0;
    let pendantCount = 0;
    let charmCount = 0; 
    let smallBox = 0;
    let largeBox = 0;

    // Cart retrieved successfully
    cartData.items.forEach(item => {
        if (item.product_type === chainType) {
          chainCount += item.quantity;
          // handleChainsLineItem(chainCount);
        } else if (item.product_type === charmType) {
          charmCount += item.quantity;
          // handleCharmsLineItem(charmCount);
        } else if (item.product_type === PendantType) {
          pendantCount += item.quantity;
          // handlePendantLineItem(pendantCount);
        } else if(item.product_type === jewelBoxSmall){
          smallBox += item.quantity;
        } else if(item.product_type === jewelBoxLarge){
          largeBox += item.quantity;
        }

      });
      
      let largeBoxCount = 0;
      let smallBoxCount = 0;
      if (chainCount > 0 && pendantCount == 0 && charmCount == 0) {
          largeBoxCount = chainCount;
          // console.log("largeBoxCount1", largeBoxCount);
      } else if (chainCount >= 1 && (pendantCount >= 1 || charmCount >= 1)) {
          largeBoxCount = chainCount;
          // console.log("largeBoxCount3", largeBoxCount);
      } else if (chainCount == 0 && (pendantCount >= 0 || charmCount >= 0)) {
          smallBoxCount = pendantCount + charmCount;
          // console.log("smallBoxCount", smallBoxCount);
      }


      if (chainCount == 0 && pendantCount == 0 && charmCount == 0) {
        setTimeout(function() {
            addBoxItem(removeLargeItem);
        }, 200);
        setTimeout(function() {
            addBoxItem(removeSmallItem);
        }, 500);
      };
 
      // add the boxes to the cart 
      if (largeBoxCount >= 1) {
          // add the large boxes to the cart 
          if (largeBox >= 1){
              var additem = {
                  id: largeBoxSKU,
                  qty: largeBoxCount,
                  call: 'updateProduct'
              };
          }
          else{
              var additem = {
                  id: largeBoxSKU,
                  qty: largeBoxCount,
                  call: 'addProduct'
              };
          }
          addBoxItem(additem);
          if(smallBox > 0){
              setTimeout(function() {
                  addBoxItem(removeSmallItem);
              }, 500);
          }
          console.log("1");
      }

      if (smallBoxCount >= 1) {
          // add the large boxes to the cart 
          if (smallBox >= 1){
              var additem = {
                  id: smallBoxSKU,
                  qty: smallBoxCount,
                  call: 'updateProduct'
              };
          }
          else{
              var additem = {
                  id: smallBoxSKU,
                  qty: smallBoxCount,
                  call: 'addProduct'
              };
          }
          addBoxItem(additem);
          if(largeBox > 0){
              setTimeout(function() {
                  addBoxItem(removeLargeItem);
              }, 500);
          }
          console.log("2");
      }
};

// Add/Update product functions
var removeSmallItem = {
    id: smallBoxSKU,
    qty: 0,
    call: 'updateProduct'
};
var removeLargeItem = {
    id: largeBoxSKU,
    qty: 0,
    call: 'updateProduct'
};

function addBoxItem(obj) {

    if (obj.call == 'addProduct') {
        $.ajax({
            type: 'POST',
            async: false,
            url: '/cart/add.js',
            data: {
                id: parseFloat(obj.id),
                quantity: parseFloat(obj.qty)
            },
            dataType: 'json',
            success: function(data) {
                document.dispatchEvent(new CustomEvent('cart:build'));
            }
        });
    } else if (obj.call == 'updateProduct') {
        $.ajax({
            type: "POST",
            url: "/cart/change.js",
            dataType: "json",
            data: {
                id: parseFloat(obj.id),
                quantity: parseFloat(obj.qty)
            },
            success: function(data) {
                document.dispatchEvent(new CustomEvent('cart:build'));
            }
        });
    } else {
        return true;
    }
};
